/* eslint-disable react/jsx-max-props-per-line */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { StatCardV2 } from '../../../../components/v2';
import { aggregateFilaMetrics } from './constants';

const FilaKpis = ({ minhaFila, loading }) => {
  const metrics = useMemo(
    () => aggregateFilaMetrics(minhaFila.itens, minhaFila),
    [minhaFila],
  );

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6, sm: 6 }}>
        <StatCardV2
          label="NSIRs em Digitação"
          valueFiltered={metrics.nsirsEmDigitacao}
          valueTotal={metrics.nsirsAtribuidas}
          totalCaption="atribuídas"
          valueFontSize="2rem"
          icon={<AssignmentIcon />}
          color="warning"
          loading={loading}
        />
      </Grid>

      <Grid size={{ xs: 6, sm: 6 }}>
        <StatCardV2
          label="Pendentes"
          valueFiltered={metrics.servicosPendentes}
          valueTotal={metrics.servicosTotal}
          totalCaption="serviços"
          valueFontSize="2rem"
          icon={<PendingActionsIcon />}
          color="warning"
          loading={loading}
        />
      </Grid>
    </Grid>
  );
};

FilaKpis.propTypes = {
  minhaFila: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

FilaKpis.defaultProps = {
  loading: false,
};

export default FilaKpis;
